<template>
  <div id="modal-overflow" ref="groupModal" class="uk-modal" uk-modal>
    <div class="uk-modal-dialog bggray w-75 no-padding">
      <button class="uk-modal-close-default" type="button" uk-close></button>
      <div class="uk-modal-header">
        <h3 class="uk-modal-title">
          {{ title ? title : $t("user_group.add_user_group") }} ({{
            selectedUsers.length
          }})
        </h3>
      </div>

      <div class="uk-modal-body">
        <div class="uk-card-header pl-0 pr-0">
          <div class="float-left d-flex">
            <button class="btn btn-sm btn-soft-secondary" type="button" @click="toggleVisibleUsers(type)">
              <i class="uil-check-square"></i> {{ selectAllText }}
            </button>
            <span v-if="allowed_number" class="btn ml-2 btn-sm bg-section-secondary text-muted">{{ $t('general.maximum') }}({{
                allowed_number
              }})</span>
          </div>
          <div class="float-right d-flex">
            <div class="btn-group bootstrap-select ml-3">
              <select v-model="per_page" class="selectpicker ml-1" tabindex="-98" @change="filterResult()">
                <option value="10">10</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="500">500</option>
                <option value="1000">1000</option>
              </select>
            </div>
          </div>
        </div>

        <div class="card mb-0">
          <!-- Card header -->
          <div class="card-header actions-toolbar border-0">
            <div class="d-flex justify-content-between align-items-center">
              <!-- <h4 class="d-inline-block mb-0"></h4> -->
              <!-- <div>
                <a
                  @click="filterResult"
                  href="javascript:void(0)"
                  class="btn btn-icon btn-hover btn-circle"
                  aria-expanded="false"
                >
                  <i class="uil-search"></i>
                </a>
                <div
                  class="uk-drop"
                  uk-drop="mode: hover; pos: right-center; offset: 0"
                  style="left: 91px; top: 159.297px"
                >
                  <span class="uk-search uk-search-navbar uk-width-1-1">
                    <input
                      class="uk-search-input shadow-0 uk-form-small"
                      type="search"
                      @change="filterResult"
                      v-model="filter.search"
                      :placeholder="$t('general.search')"
                      autofocus=""
                    />
                  </span>
                </div> -->
              <div class="row" style="width:100%">
                <div class=" col-md-1  search-icon ">
                  <i class="uil-search"></i>
                </div>
                <div class="col-md-11 uk-search uk-search-navbar" style="margin-left:-2rem">
                  <input v-model="filter.search" :placeholder="$t('general.search')" class="uk-search-input shadow-0 uk-form-small"
                         type="search"/>
                </div>
              </div>
              <div class="d-flex">
                <!-- Shorting -->
                <a :uk-tooltip="$t('filters.order.sort')" aria-expanded="false"
                   class="btn btn-icon btn-hover btn-circle" href="javascript:void(0)" title="">
                  <i class="uil-list-ui-alt"></i>
                </a>
                <div ref="filterRef" class="uk-dropdown"
                     uk-dropdown="pos: bottom-right ; mode: click ;animation: uk-animation-scale-up">
                  <ul class="uk-nav uk-dropdown-nav">
                    <li class="uk-active">
                      <a href="javascript:void(0)" @click="sortOrder('asc', 'name')">{{ $t("filters.order.a_z") }}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="sortOrder('desc', 'name')">{{ $t("filters.order.z_a") }}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="sortOrder('asc', 'created_at')">
                        {{ $t("filters.order.created_at_asc") }}</a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="sortOrder('desc', 'created_at')">
                        {{ $t("filters.order.created_at_desc") }}</a>
                    </li>
                  </ul>
                </div>
                <!-- Filter -->
                <a :uk-tooltip="$t('general.filter_list')" class="btn btn-icon btn-hover  btn-circle"
                   href="javascript:void(0)">
                  <i class="uil-filter"></i>
                </a>
                <UserFilter id="userFilterModal" :has-status="has_user_status" :isDate="false"
                            @getFilter="getFilter($event)"></UserFilter>
              </div>
            </div>
          </div>
          <!-- Table -->
          <div class="table-responsive">
            <table class="table align-items-center">
              <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">{{ this.$t('general.first_name_and_last_name') }}</th>
                <th scope="col">{{ this.$t('general.title_position') }}</th>
                <th scope="col">{{ $t("general.corporation") }}</th>
                <th scope="col">{{ this.$t('general.added_at') }}</th>
                <th scope="col">{{ this.$t('users.last_login_date') }}</th>
                <th scope="col"></th>
              </tr>
              </thead>
              <tbody class="list">
              <tr v-for="item in formattedItem" :key="item.id">
                <th scope="row">
                  <div class="media align-items-center">
                    <input v-if="!existing_users.includes(item.id)" :id="'checkbox_' + item.id"
                           :checked="selectedUsers.some(r => r.id === item.id)" type="checkbox"
                           @change="addUser($event, item)"/>
                    <input v-else :checked="true" class="disabled" disabled type="checkbox"/>
                  </div>
                </th>

                <th scope="row">
                  <div class="media align-items-center">
                    <div>
                      <div class="avatar-parent-child" style="width: max-content">
                        <img :src="item.photo_link" alt="Image placeholder" class="avatar rounded-circle"/>
                        <span :class="item.is_online ? 'bg-success' : 'bg-offline'
                              " class="avatar-child avatar-badge"></span>
                      </div>
                    </div>
                    <div class="media-body ml-4">
                      <a class="name h6 mb-0 text-sm" @click="setActiveItem(item)">{{ item.fullname }}</a>
                      <small class="d-block font-weight-bold">#{{ item.id }}</small>
                    </div>
                  </div>
                </th>
                <td>{{ item.title }}</td>
                <td>{{ item.corporateName }}</td>
                <td>{{ item.created_at }}</td>
                <td>{{ item.last_login_at }}</td>
                <td class="text-right">
                  <!-- Actions -->
                  <div class="actions ml-3">
                    <a class="btn btn-icon btn-hover btn-sm btn-circle" :uk-tooltip="$t('general.user_profil')"
                       @click="setActiveItem(item)">
                      <i class="uil-user"></i>
                    </a>
                  </div>
                </td>
              </tr>
              <!--user item-->
              </tbody>
            </table>
          </div>
        </div>
        <pagination :pagination="pagination" class="mt-3" @changePage="setPage($event)"></pagination>

        <div class="uk-card-header">
          <div class="float-right">
            <button class="uk-button uk-button-outline-default mr-2 small closeButton" type="button"
                    @click="cancelSelection">
              <i class="icon-arrow-left"></i> {{ $t('general.back') }}
            </button>
            <button class="uk-button uk-button-primary small closeButton" type="button" @click="setSelectedUser">
              <i class="icon-feather-save"></i> {{ $t("general.save") }}

            </button>
          </div>
        </div>
      </div>
    </div>
    <UserProfile
        v-if="activeItem"
        :item="activeItem"
        :user_detail="formattedUserDetail"
        @modalClosed="activeItem = null"
    ></UserProfile>
  </div>
</template>

<script>
import module, {
  BASE_URL,
  GET_ITEMS,
  MODULE_NAME,
  ERROR,
  ITEMS,
} from "@/core/services/store/user.module";

import company_module, {
  ONLINE_USERS,
  MODULE_NAME as COMPANY_MODULE,
} from "@/core/services/store/company.module";
import user_detail_module, {
  GET_ITEM as GET_USER_DETAIL,
  ITEM as USER_DETAIL,
  MODULE_NAME as USER_DETAIL_MODULE,
} from "@/core/services/store/user_detail.module";

import store from "@/core/services";
import moment from "moment";
import Pagination from "@/assets/components/Pagination";
import UserFilter from "@/view/company/User/Filter";
import UserProfile from "@/view/company/User/UserProfile/index.vue";
import {
  getAssignedCorporateAccess,
  applyAssignedCorporateToFilter,
} from "@/core/services/userCorporateAccess.service";

const _USER_DETAIL_MODULE = USER_DETAIL_MODULE;
const _USER_MODULE = MODULE_NAME;
const _COMPANY_MODULE = COMPANY_MODULE;

export default {
  name: "AddToGroupModal",
  components: { Pagination, UserFilter, UserProfile },
  props: {
    title: {
      required: false,
      default: "",
    },
    allowed_number: {
      required: false,
      type: Number,
      default: 0,
    },
    has_user_status: {
      type: Boolean,
      default: false,
    },
    existing_users: {
      required: false,
      type: Array,
      default: () => {
        return [];
      },
    },
    selected_users: {
      required: false,
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      pagination: null,
      activeItem: null,
      page: 1,
      per_page: 10,
      filter: {
        search: null,
        orderBy: "desc",
        sort: "id",
      },
      selectedUsers: [],
      type: true,
      selectAllText: this.$t('general.select_all'),
      keepFilter: null,
    };
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_USER_MODULE, module);
    registerStoreModule(_COMPANY_MODULE, company_module);
    registerStoreModule(_USER_DETAIL_MODULE, user_detail_module);
  },
  computed: {
    user_detail: {
      get() {
        return store.getters[USER_DETAIL_MODULE + "/" + USER_DETAIL];
      },
      set(value) {
      },
    },
    formattedUserDetail() {
      if (this.user_detail === null) return null;
      return this.user_detail;
    },
    onlineUsers() {
      return store.getters[_COMPANY_MODULE + "/" + ONLINE_USERS];
    },
    items: {
      get() {
        return store.getters[_USER_MODULE + "/" + ITEMS];
      },
      set(value) {
      },
    },
    errors: {
      get() {
        return store.getters[MODULE_NAME + "/" + ERROR];
      },
      set(value) {
      },
    },
    formattedItem() {
      if (this.items === null || !("data" in this.items)) return [];
      let results = [];
      this.pagination = this.items;
      const onlineUsers = Array.isArray(this.onlineUsers) ? this.onlineUsers : [];
      this.items.data.forEach((item) => {
        results.push({
          id: item.id,
          name: item.name,
          surname: item.surname,
          dob: item.dob ? item.dob : "-",
          email: item.email,
          phone: item.phone,
          photo_link: item.photo_link,
          is_online: !!onlineUsers.find(
              (onlineUser) => onlineUser.user == item.id && onlineUser.status
          ),
          fullname: [item.name, item.surname].join(" "),
          title: item.title ? item.title.name : "-",
          corporateName: item.corporate?.name || "-",
          created_at: item.created_at
              ? moment(item.created_at).format("DD/MM/YYYY HH:mm:ss")
              : "-",
          last_login_at: item.last_login_at
              ? moment(item.last_login_at).format("DD/MM/YYYY HH:mm:ss")
              : "-",
        });
      });

      return results;
    },
  },
  methods: {
    cloneUsers(users = []) {
      return Array.isArray(users) ? users.map((user) => ({ ...user })) : [];
    },
    syncSelectedUsersFromProps() {
      this.selectedUsers = this.cloneUsers(this.selected_users);
      this.selectAllText = this.$t('general.select_all');
      this.type = true;
    },
    closeGroupModal() {
      if (this.$refs.groupModal) {
        const modal = UIkit.modal(this.$refs.groupModal);
        if (modal) modal.hide();
      }
    },
    getUserDetail(id) {
      store.dispatch(USER_DETAIL_MODULE + "/" + GET_USER_DETAIL, {
        url: "api/user/detail-admin" + "/" + id,
      });
    },
    setActiveItem(item) {
      this.activeItem = item;
      UIkit.modal("#modal-profile").show();
    },
    getFilter(value) {
      this.page = 1;
      this.filterResult(value);
    },
    // aktif filtreden (keepFilter) tek noktada istek parametreleri üretilir
    buildRequestFilters() {
      const activeFilter = this.keepFilter || {};

      let filters = {
        like: this.filter.search,
        page: this.page,
        per_page: this.per_page,
        order: this.filter.orderBy,
        sort: this.filter.sort,
      };

      if (this.has_user_status) {
        // aktif-pasif kullanıcı durumu
        if (activeFilter.user_status === 1) {
          filters['status'] = true;
        } else if (activeFilter.user_status === 0) {
          filters['status'] = false;
        } else {
          filters['status'] = null;
        }
      }

      if (activeFilter.company_id) {
        filters['company_id'] = activeFilter.company_id;
      }

      // {id, name} listesi tutan filtreler API için id dizisine çevrilir
      Object.entries(activeFilter).forEach(([key, value]) => {
        if (!value || !Array.isArray(value) || key === 'company_id') return;

        let ids = value.map((item) => item.id);

        // "Tümü" seçiliyse (id null) assignment_id gönderilmez
        if (key === 'assignment_id' && value.some((assignment) => assignment?.id === null)) {
          ids = null;
        }

        filters[key] = JSON.stringify(ids);
      });

      return filters;
    },
    filterResult(filter = null) {
      // Yeni filtre geldiyse sakla; gelmediyse (sayfalama, sıralama, arama)
      // en son uygulanan filtreyle devam et
      if (filter) {
        this.keepFilter = { ...filter };
      }

      this.$store.dispatch(MODULE_NAME + "/" + GET_ITEMS, {
        url: BASE_URL,
        filters: this.buildRequestFilters(),
      }).then((response) => {
        if (!response || !Array.isArray(response.data)) return;
        response.data.forEach((responseData) => {
          let flag = true;
          this.selectedUsers.forEach((selectedUsers) => {
            if (responseData.id === selectedUsers.id) {
              flag = false;
            }
          })
          if (flag) {
            this.selectAllText = this.$t('general.select_all');
            this.type = true;
          }
        })
      });
    },
    addUser(eve, user) {
      let users = this.selectedUsers;
      let index = users
          .map((u) => {
            return u.id;
          })
          .indexOf(user.id);

      if (index === -1) {
        if (this.allowed_number == 0 || users.length < this.allowed_number)
          users.push(user);
        else eve.target.checked = false;
      } else users.splice(index, 1);
    },
    sortOrder(orderBy, sort) {
      this.page = 1;
      this.filter.orderBy = orderBy;
      this.filter.sort = sort;
      this.filterResult();
      UIkit.dropdown(this.$refs["filterRef"]).hide(0);
    },
    setPage(page) {
      this.page = page;
      // Yeni filtre gönderme; keepFilter'daki son filtreyle sadece sayfa değişsin
      this.filterResult();
    },
    toggleVisibleUsers(val) {
      if (val) {
        const selectedIds = this.selectedUsers.map((user) => user.id);
        this.formattedItem.forEach((item) => {
          if (
              (this.allowed_number != 0 &&
                  this.selectedUsers.length >= this.allowed_number) ||
              this.existing_users.includes(item.id) ||
              selectedIds.includes(item.id)
          ) {
            return;
          }
          this.addUser(null, item);
        });
        this.selectAllText = this.$t('general.deselect_all');
        this.type = false;
        return;
      }

      const currentPageIds = this.formattedItem.map((item) => item.id);
      this.selectedUsers = this.selectedUsers.filter(
          (user) => !currentPageIds.includes(user.id)
      );
      this.selectAllText = this.$t('general.deselect_all');
      this.type = true;
    },
    allToggle(val) {
      if (val) {
        this.formattedItem.forEach((item) => {
          if (
              (this.allowed_number != 0 &&
                  this.selectedUsers.length >= this.allowed_number) ||
              this.existing_users.includes(item.id)
          )
            return false;
          this.addUser(null, item);
          $("#checkbox_" + item.id).prop("checked", true);
          this.selectAllText = this.$t('general.deselect_all');
          this.type = false;
        });
      } else {
        this.formattedItem.forEach((item) => {
          $("#checkbox_" + item.id).prop("checked", false);
          this.selectedUsers.forEach((data, index) => {
            if (data.id === item.id) {
              this.selectedUsers.splice(index, 1);
            }
          })
        });

        // this.selectedUsers = [];
        this.selectAllText = this.$t('general.select_all');
        this.type = true;
      }
    },
    setSelectedUser() {
      const selectedUsers = this.cloneUsers(this.selectedUsers);
      this.$emit("getList", selectedUsers);
      this.closeGroupModal();
    },
    cancelSelection() {
      this.syncSelectedUsersFromProps();
      this.closeGroupModal();
    },
  },
  async mounted() {
    // company_admin değilse ve bir şirkete atanmışsa
    // ilk yüklemede sadece o şirketin kullanıcıları gelsin
    const corporateAccess = await getAssignedCorporateAccess();
    this.keepFilter = applyAssignedCorporateToFilter(this.keepFilter, corporateAccess);

    this.filterResult();
    this.debouncedFilterSearch = _.debounce(() => this.filterResult(), 500);
    $(".selectpicker").selectpicker();
    this.syncSelectedUsersFromProps();

    if (this.$refs.groupModal) {
      UIkit.util.on(this.$refs.groupModal, "show", this.syncSelectedUsersFromProps);
      UIkit.util.on(this.$refs.groupModal, "hidden", this.syncSelectedUsersFromProps);
    }
  },
  watch: {
    "filter.search"() {
      this.page = 1;
      this.debouncedFilterSearch();
    },
  },
  beforeDestroy() {
    if (this.$refs.groupModal) {
      UIkit.util.off(this.$refs.groupModal, "show", this.syncSelectedUsersFromProps);
      UIkit.util.off(this.$refs.groupModal, "hidden", this.syncSelectedUsersFromProps);
    }

    const modal = UIkit.modal("#modal-profile");
    if (modal) modal.$destroy(true);
  },
};
</script>

<style scoped>
input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}

.uk-alert {
  margin: 0;
}
</style>
